import React from "react";
import { useLocation } from "react-router-dom";
import "../styles/BookingSuccessPage.scss";

export default function BookingSuccessPage() {
  const { state } = useLocation();
  const data = state;

  if (!data) return <div>No booking data found</div>;

  return (
    <div className="booking-page container py-5 d-flex justify-content-center">
      <div className="booking-card shadow p-4 bg-white">

        {/* HEADER */}
        <div className="row mb-4">
          <div className="col-auto">
            <img
              src={data.movie.thumbnail}
              alt="poster"
              className="poster-img img-fluid rounded shadow-sm"
            />
          </div>

          <div className="col d-flex flex-column justify-content-center">
            <h1 className="h3 fw-bold mb-1">{data.message}</h1>

            <p className="text-muted small mb-0">
              <strong>Booking ID:</strong> {data.booking_id}
            </p>
          </div>
        </div>

        {/* DETAILS */}
        <div className="details-list">
          <Detail label="Movie" value={data.movie.name} />
          <Detail label="Theatre" value={data.theatre.name} />
          <Detail label="Screen" value={data.screen.name} />
          <Detail label="Show Date" value={data.show_date} />
          <Detail label="Show Time" value={data.show_time} />
          <Detail label="Amount" value={`${data.amount} (Status: ${data.status})`} />
        </div>

        {/* SEATS */}
        <h2 className="h4 fw-semibold mt-4">Seats</h2>

        <div className="table-responsive">
          <table className="table table-bordered table-hover table-sm">
            <thead className="table-light">
              <tr>
                <th>Section</th>
                <th>Block</th>
                <th>Row</th>
                {/* <th>Position</th> */}
                <th>Number</th>
                <th>Type</th>
              </tr>
            </thead>

            <tbody>
              {data.seats.map((s) => (
                <tr key={s.id}>
                  <td>{s.section}</td>
                  <td>{s.block}</td>
                  <td>{s.row}</td>
                  {/* <td>{s.position}</td> */}
                  <td>{s.number}</td>
                  <td>{s.seat_type}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* FOOTER */}
        <p className="text-muted small mt-4">
          Show this confirmation at the theatre entrance.
        </p>

        <p className="text-center small text-muted">
          If you have questions, contact support.
        </p>

        <p className="text-center small text-secondary">© 2025 Getam</p>

        <div className="text-center mt-4">
          <button className="btn btn-dark px-4" onClick={() => window.print()}>
            Print Ticket
          </button>
        </div>

      </div>
    </div>
  );
}

function Detail({ label, value }) {
  return (
    <div className="detail-row d-flex border-bottom py-2">
      <span className="label fw-medium">{label}</span>
      <span className="value ms-3">{value}</span>
    </div>
  );
}
